import React from 'react';
import { BreadcrumbLink } from './BreadcrumbLink';
import { FixMeLater } from '../../utils';
import { ScrollerItem } from '../Scroller';
import { useCulture } from '../../culture';

export type BreadcrumbItemProps = {
    /**
     * The child link component. Expects `BreadcrumbLink`.
     */
    children: React.ReactElement<typeof BreadcrumbLink>;

    /**
     * @ignore
     */
    last?: boolean;

    /**
     * @ignore
     */
    bcId?: string;

    /**
     * @ignore
     */
    bcRef?: string;

    /**
     * @ignore
     */
    position?: string;
};

export const BreadcrumbItem = React.forwardRef(function BreadcrumbItem(
    props: BreadcrumbItemProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { children, last, bcId, bcRef, position, ...other } = props;

    const { dir } = useCulture();
    const isRTL = dir === 'rtl';

    return (
        <ScrollerItem
            ref={ref}
            id={bcId}
            itemScope={true}
            itemProp="itemListElement"
            itemType="https://schema.org/ListItem"
            itemRef={bcRef}
            data-breadrumb-item={true}
            {...other}
        >
            {children}
            <meta itemProp="position" content={position} />
            {!last && <span>{isRTL ? '\\' : '/'}</span>}
        </ScrollerItem>
    );
});
